import React from "react";
import withLayout from "../../../components/desktop/layout/component";
import { Helmet } from "react-helmet-async";
import TuCibilTermsContent from "../../../components/shared/tu-cibil-terms-content";
import { appUrl } from "../../../constants/url-constants";

const TuCibilTerms = () => {
    return (
        <React.Fragment>
            <Helmet>
                <title>Cars24 | terms of use</title>
                <link href={`${appUrl()}/tu-cibil-terms/`} rel="canonical" />
            </Helmet>
            <TuCibilTermsContent />
        </React.Fragment>
    );
};

export default withLayout(TuCibilTerms);
